import { createTheme } from "@mui/material/styles";
import { palette } from "./Palette";
import "@mui/x-data-grid/themeAugmentation";

const theme = createTheme({
  palette: palette,

  typography: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontSize: 14,
    h6: {
      fontWeight: 600,
      fontSize: "1.2rem",
    },
    // h4: {
    //   fontSize: "1.2rem",
    // },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: palette.background.paper,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top 10px left 20px",
          backgroundSize: "80px auto",
        },

        ".custom-box": {
          display: "flex",
          alignItems: "center",
          padding: "10px",
          cursor: "pointer",
          borderRadius: "0 5px 0 5px",
          transition: "background-color 0.3s ease",
          whiteSpace: "nowrap",
          overflow: "hidden",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
          },
          "&.selected": {
            backgroundColor: "#ffffff !important",
            color: "#02A1FF !important",
            margin: "0 3px",
            "& .custom-box-icon": {
              color: "#02A1FF !important",
            },
            "& .custom-box-text": {
              color: "#02A1FF !important",
            },
          },
        },
        ".custom-box-icon": {
          color: "#ffffff",
          marginRight: "15px",
          minWidth: "40px",
          textAlign: "center",
        },
        ".custom-box-text": {
          color: "#ffffff",
          fontSize: "1rem",
          fontWeight: "500",
          transition: "opacity 0.3s ease, width 0.3s ease",
        },
        ".drawer-collapsed .custom-box-text": {
          opacity: 0,
          width: 0,
          overflow: "hidden",
        },
        ".drawer-expanded .custom-box-text": {
          opacity: 1,
          width: "auto",
        },
        ".submenu-item": {
          paddingLeft: "20px",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
        },

        columnHeaders: {
          backgroundColor: "#ffffff",
          borderBottom: "2px solid #01AFAE",
        },

        columnHeader: {
          paddingLeft: 0,
          paddingRight: 0,
        },

        columnHeaderTitleContainer: {
          justifyContent: "center",
        },

        columnHeaderTitle: {
          color: palette.primary.main,
          fontWeight: "bold",
          textAlign: "center",
          whiteSpace: "normal",
        },

        overlay: {
          backgroundColor: "#ffffff !important",
        },

        row: {
          "&:nth-of-type(even) .MuiDataGrid-cell": {
            backgroundColor: "#f5f5f5",
          },
          "&:nth-of-type(odd) .MuiDataGrid-cell": {
            backgroundColor: "#e0e0e0",
          },
        },

        cell: {
          color: "#000",
          paddingLeft: 20,
        },
      },
    },

    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: palette.primary.main,
          color: palette.text.primary,
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
        containedPrimary: {
          backgroundColor: palette.primary.button,
          color: " #252118A6",
          fontSize: "16px",
          "&:hover": {
            backgroundColor: "#ffc357FF",
          },
        },
        containedSecondary: {
          backgroundColor: palette.secondary.main,
          color: palette.secondary.contrastText,
          fontSize: "16px",
          "&:hover": {
            backgroundColor: "#FFD15C",
          },
        },
        containedSuccess: {
          backgroundColor: palette.primary.main,
          color: palette.primary.contrastText,
          "&:hover": {
            backgroundColor: "primary.main",
          },
        },
        containedInfo: {
          backgroundColor: palette.text.secondary,
          color: palette.text.primary,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: palette.primary.contrastText,
            fontSize: "16px",

            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#01afae",
            },

            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: palette.primary.main,
            },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: palette.primary.main,
              borderWidth: 2,
            },
            "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
              borderColor: palette.text.disabled,
            },
          },

          "& .MuiInputBase-input": {
            paddingTop: "14px !important",
            paddingBottom: "14px !important",
          },
        },
      },
    },
  },
});

export default theme;

/** compact: 40px fields for dense internal forms (Account Management, OOTWUI-024); pair with size="small". */
export const getTextFieldStyles = (compact = false) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    backgroundColor: "grey.50",
    "&:hover fieldset": {
      borderColor: "primary.main",
    },
    "&.Mui-focused fieldset": {
      borderColor: "primary.main",
      borderWidth: 2,
    },
    height: compact ? "40px" : "56px",
  },
  "& .MuiInputBase-input": {
    py: compact ? 1 : 1.75,
  },
});
export const getDescriptionFieldStyles = () => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    backgroundColor: "grey.50",
    "&:hover fieldset": {
      borderColor: "primary.main",
    },
    "&.Mui-focused fieldset": {
      borderColor: "primary.main",
      borderWidth: 2,
    },
  },
});
export const getSelectFieldStyles = () => ({
  borderRadius: 2,
  backgroundColor: "grey.50",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "primary.main",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "primary.main",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "primary.main",
    borderWidth: 2,
  },
  height: "56px",
  "& .MuiSelect-select": {
    paddingTop: "8px",
    paddingBottom: "8px",
    display: "flex",
    alignItems: "center",
  },
});
